import { GlobalState } from 'store/modules';

import { RecentlyViewedItem } from '../types';

export const getRecentlyViewedMap = (state: GlobalState): Hash<RecentlyViewedItem> =>
  state.recentlyViewed.items;
